// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import CampaignController from "./campaign_controller"
application.register("campaign", CampaignController)

import CampaignsController from "./campaigns_controller"
application.register("campaigns", CampaignsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import FormController from "./form_controller"
application.register("form", FormController)

import InstantModalController from "./instant_modal_controller"
application.register("instant-modal", InstantModalController)

import IosPwaCheckerController from "./ios_pwa_checker_controller"
application.register("ios-pwa-checker", IosPwaCheckerController)

import LoadingSpinnerController from "./loading_spinner_controller"
application.register("loading-spinner", LoadingSpinnerController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import NavigatorController from "./navigator_controller"
application.register("navigator", NavigatorController)

import OffcanvasController from "./offcanvas_controller"
application.register("offcanvas", OffcanvasController)

import PayoutController from "./payout_controller"
application.register("payout", PayoutController)

import PwaController from "./pwa_controller"
application.register("pwa", PwaController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import UserBankController from "./user_bank_controller"
application.register("user-bank", UserBankController)
